import { render, staticRenderFns } from "./checkmore.vue?vue&type=template&id=4a79a3c0&scoped=true"
import script from "./checkmore.vue?vue&type=script&lang=js"
export * from "./checkmore.vue?vue&type=script&lang=js"
import style0 from "./checkmore.vue?vue&type=style&index=0&id=4a79a3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79a3c0",
  null
  
)

export default component.exports